
<template>
  <div class="layout">
    <div class="inner">
      <div class="leader-box">
        <div class="title">领先技术产品</div>
        <div class="subtitle">助您轻松实现各类业务场景，高效完成任务指标</div>
        <div class="example-3d">
          <swiper class="swiper" :options="swiperOption">
            <swiper-slide>
              <div class="top">
                <div class="circle"><i class="iconfont iconmianshi"></i></div>
              </div>
              <div class="middle">面试模式多样</div>
              <div class="bottom">
                系统支持视频通话、语音通话、共享桌面、共享文件演示、在线编程、PC端&移动端面试等模式。面试中如遇视频故障，系统支持PC端设备和移动端设备自由切换。
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="top">
                <div class="circle"><i class="iconfont iconhuojian1"></i></div>
              </div>
              <div class="middle">面试功能强大</div>
              <div class="bottom">
                面试设备自助检测、音视频设备自助切换、一键修复视频故障、查看候选人、简历预览、查看笔试测评报告、自定义评价表等。支持对接主流招聘系统平台：Moka、北森、大易、智联招聘、还可定制对接客户的OA等系统。
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="top">
                <div class="circle"><i class="iconfont iconmingdan"></i></div>
              </div>
              <div class="middle">叫号系统便捷</div>
              <div class="bottom">
                面试官无需培训，使用赛码叫号系统，完美管理每日的大批量候选人面试，多部门协同面试，多轮次一站式面试，均由叫号系统完成，节省现场组织协调工作人员80%的人力。
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="top">
                <div class="circle"><i class="iconfont iconjiankong1"></i></div>
              </div>
              <div class="middle">监控系统全面</div>
              <div class="bottom">
                每日大批量面试候选人时，HR实时掌控面试双方到场率，每轮通过率，每位面试官的平均用时、通过率及工作量等数据，及时协调面试官人手，避免候选人等待，避免面试官通过标准偏差较大。
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="top">
                <div class="circle"><i class="iconfont iconshell"></i></div>
              </div>
              <div class="middle">面试数据安全</div>
              <div class="bottom">
                赛码在线面试系统已经获得国家信息系统安全等级保护三级认证，确保客户面试数据安全。同时支持并发5万人以上同时在线面试，系统流畅不卡顿。
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      isMobile: false,
      swiperOption: {},
    }
  },
  created() {
    this.isMobile = this.$store.state.app.device
    this.init()
  },
  methods: {
    init() {
      this.swiperOption = {
        autoplay: true,
        loop: true,
        slidesPerView: this.isMobile ? 3 : 5,
        centeredSlides: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        on: {
          setTranslate: function () {
            const slides = this.slides
            for (let i = 0; i < slides.length; i++) {
              let slide = slides.eq(i)
              let progress = slides[i].progress
              // slide.html(progress.toFixed(2)); 看清楚progress是怎么变化的
              slide.css({ opacity: '', background: '' })
              slide.transform('') // 清除样式
              slide.transform('scale(' + (1 - Math.abs(progress) / 8) + ')')
            }
          },
          setTransition: function (transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition)
            }
          },
        },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  height: 100%;
  .inner {
    margin: auto;
    position: relative;
    top: -30px;
  }
}
.leader-box {
  text-align: center;
  font-weight: 300;
  padding: 50px 0px 0px;

  .title {
    padding: 20px 0px;
    font-size: 36px;
  }
  .subtitle {
    font-size: 16px;
  }
  .example-3d {
    width: 1200px;
    margin: 0px auto;
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .swiper {
    height: 100%;
    width: 100%;
    cursor: pointer;
    .swiper-slide {
      text-align: center;
      background-color: #fff;
      background-position: center;
      background-size: cover;
      border: 1px solid #eee;
      color: #333;
      min-height: 450px;
      &:hover {
        box-shadow: #eff0f2 0px 2px 12px 6px;
      }
      .top {
        padding: 40px 20px 0px;
        .circle {
          background: url('~@/static/images/interview-3-bg.png') no-repeat center
            center;
          width: 124px;
          height: 124px;
          text-align: center;
          padding: 45px 20px 0px;
          margin: 0px auto;
          i {
            font-size: 35px;
            color: #fff;
          }
        }
      }
      .middle {
        padding: 30px 0px 0px;
        font-size: 24px;
      }
      .bottom {
        padding: 20px;
        font-size: 13px;
        letter-spacing: 2px;

        text-align: justify;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .leader-box {
    padding: 60px 0 10px 0;
    .title {
      font-size: 24px !important;
      width: 380px;
    }
    .subtitle {
      width: 380px;
    }
  }

  .example-3d {
    width: 600px !important;
    transform: scale(0.8);
    transform: translate(-20%, 0%);
    padding-bottom: 0px !important;
    .swiper {
      width: 550px;
      .swiper-slide {
        width: 20px;
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .leader-box {
    padding: 60px 0 10px 0;

    .title {
      font-size: 24px !important;
    }
  }

  .example-3d {
    width: 800px !important;
    transform: scale(0.8);
    transform: translate(-20%, 0%);
    padding-bottom: 0px !important;

    .swiper {
      width: 550px;
      margin-left: 35%;

      .swiper-slide {
        width: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/interview/leader.vue